//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//登录逻辑
export default {
	data() {
		return {
			_telephone: '',
			_password: '',
			dialog: false,
			openCon:''
		}
	},
	mounted(){
		this.$store.state.sildeShow = false;
	},
	methods: {
		handlechange(val) {
			console.log(`you choose ${val}`)
		},

		handleInput(val) {
			this.dataSource = [
				val,
				val + val,
				val + val + val
			]
		},
		open() {
			this.dialog = true
		},
		close() {
			this.dialog = false
		},
		//前往注册
		toRegister() {
			location.href = "#/register"
		},
		//点击登录
		gotoLogin() {
			var inputCon = document.getElementsByClassName("mu-text-field-input");
			this._telephone = inputCon[0].value;
			this._password = inputCon[1].value;
			console.log(this._telephone, this._password);
			//将用户名存入cookie
			document.cookie = 'tel=' + this._telephone;
			//发送ajax请求
			this.sendLogin();
			
		},
		sendLogin: function() {
			this.$ajax({
				url: 'http://localhost:12345/login',
				params: {
					telephone: this._telephone,
					password: this._password
				}
			})
			.then((res) => {
			
				console.log(res);
				this.open();
				if(res.data.user.length == 0) {
					console.log(123);
					this.openCon = '登录帐号或登录密码错误'
				}
				if(res.data.user.length == 1) {
					console.log(222);
					console.log(this.$store.state.loginStatus);
					var cookies = document.cookie;
					if(cookies) {
						console.log(666)
						var arr = cookies.split('; ');
						arr.forEach(function(item) {
							var temp = item.split('=');	
							location.href = '/app/newSong/';		
						})
					}
				}
			})
			.catch((error) => {
				console.log(error);
				this.openCon='香菇，登录失败了,请重新输入';
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/xlogin.vue